import React, { useEffect, useState } from "react";
import "./Transaction.css";
import noData from "../Image/noData.png";
import {
  Tabs,
  Table,
  message,
  Button,
  Spin,
  InputNumber,
  Modal,
  Select,
  Tooltip,
  Descriptions,
  Popconfirm,
  Tag,
  Statistic,
  DatePicker,
  Space,
  Input,
} from "antd";
import {
  EyeOutlined,
  ReadOutlined,
  RollbackOutlined,
  SmileOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { db } from "../Firebase/FirebaseConnection";
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import moment from "moment";
const { RangePicker } = DatePicker;

const Transaction = () => {
  const [issuedBooks, setIssuedBooks] = useState([]);
  const [returnedBooks, setReturnedBooks] = useState([]);
  const [isStatusModalVisible, setIsStatusModalVisible] = useState(false);
  const [isFineModalVisible, setIsFineModalVisible] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [fine, setFine] = useState(0);
  const [isClearModalVisible, setIsClearModalVisible] = useState(false);
  const [selectedBookForClear, setSelectedBookForClear] = useState(null);
  const [clearStatus, setClearStatus] = useState("");
  const [damageType, setDamageType] = useState("");
  const [paidBooks, setPaidBooks] = useState([]);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [selectedBookDetails, setSelectedBookDetails] = useState(null);
  const [isReturnedBook, setIsReturnedBook] = useState(false);
  const [bookType, setBookType] = useState("issued");
  const [loading, setLoading] = useState(false);
  const [isReturnModalVisible, setIsReturnModalVisible] = useState(false);
  const [returningBook, setReturningBook] = useState(null);
  const [copiesToReturn, setCopiesToReturn] = useState(1);
  const [returnStatus, setReturnStatus] = useState("Good");
  const [returnFine, setReturnFine] = useState(0);
  const [resolveType, setResolveType] = useState("");
  const [issuedDateRange, setIssuedDateRange] = useState([]);
  const [summaryCounts, setSummaryCounts] = useState({
    issued: 0,
    returned: 0,
    damagedMissing: 0,
    paidNotReturned: 0,
  });

  const fetchIssuedBook = async () => {
    try {
      const issuedBookRef = collection(db, "issuedBooks");
      const issuedBookSnapshot = await getDocs(issuedBookRef);
      const issuedData = issuedBookSnapshot.docs.map((doc) => ({
        ...doc.data(),
        key: doc.id,
      }));

      setIssuedBooks(issuedData);
    } catch (error) {
      message.error("Failed to load Issued Books.");
    }
  };

  const fetchReturnedBooks = async () => {
    try {
      const returnedBookRef = collection(db, "returnedBooks");
      const returnedBookSnapshot = await getDocs(returnedBookRef);
      const returnedData = returnedBookSnapshot.docs.map((doc) => ({
        ...doc.data(),
        key: doc.id,
      }));

      setReturnedBooks(returnedData);
    } catch (error) {
      message.error("Failed to load Returned Books.");
    }
  };

  const calculateRemainingDuration = (dueDate) => {
    if (!dueDate || !(dueDate instanceof Timestamp)) return "N/A";

    const dueDateObj = dueDate.toDate();
    const currentDate = new Date();

    const totalDaysDifference = Math.ceil(
      (dueDateObj.getTime() - currentDate.getTime()) / (1000 * 3600 * 24)
    );

    if (totalDaysDifference <= 0) {
      return "Overdue";
    }

    const months = Math.floor(totalDaysDifference / 30);
    const days = totalDaysDifference % 30;

    const monthStr =
      months > 0 ? `${months} month${months > 1 ? "s" : ""}` : "";
    const dayStr = days > 0 ? `${days} day${days > 1 ? "s" : ""}` : "";

    return `${monthStr}${monthStr && dayStr ? " & " : ""}${dayStr}`;
  };

  const damagedAndMissingBooks = issuedBooks.filter(
    (book) => book.status === "Damaged" || book.status === "Missing"
  );

  const filteredIssuedBooks = issuedBooks.filter(
    (book) =>
      book.status !== "Damaged" &&
      book.status !== "Missing" &&
      book.status !== "Resolved" &&
      book.status !== "Paid"
  );

  const resolvedBooks = issuedBooks.filter(
    (book) => book.status === "Resolved"
  );
  const handleClearClick = (book) => {
    setSelectedBookForClear(book);
    setIsClearModalVisible(true);
  };

  const totalResolved = issuedBooks
    .filter((book) => book.status === "Resolved")
    .reduce((sum, book) => sum + (book.copiesBorrowed || 0), 0);

  const handleClearStatus = async () => {
    setLoading(true);
    if (!clearStatus) {
      message.error("Please select a status.");
      setLoading(false);
      return;
    }

    if (clearStatus === "Resolved" && !resolveType) {
      message.error("Please select if the book was repaired or replaced.");
      setLoading(false);
      return;
    }

    try {
      const bookRef = doc(db, "issuedBooks", selectedBookForClear.key);
      const oldStatus = selectedBookForClear.status;

      await updateDoc(bookRef, {
        status: clearStatus,
        resolveType: clearStatus === "Resolved" ? resolveType : null,
        resolvedDate: clearStatus === "Resolved" ? Timestamp.now() : null,
        resolvedBy:
          clearStatus === "Resolved" ? localStorage.getItem("userName") : null,
      });

      const booksRef = collection(db, "books");
      const booksSnapshot = await getDocs(booksRef);
      const matchedBook = booksSnapshot.docs.find(
        (doc) => doc.id === selectedBookForClear.bookId
      );

      if (matchedBook) {
        const matchedBookRef = doc(db, "books", matchedBook.id);
        let currentTotalCopies = parseInt(matchedBook.data().totalCopies) || 0;
        let currentCopiesAvailable =
          parseInt(matchedBook.data().copiesAvailable) || 0;

        if (isNaN(currentCopiesAvailable)) {
          currentCopiesAvailable = currentTotalCopies;
        }

        let updateData = {};

        if (
          (oldStatus === "Missing" && clearStatus === "Resolved") ||
          (oldStatus === "Damaged" && clearStatus === "Resolved")
        ) {
          await adjustInventory(
            selectedBookForClear.bookId,
            +selectedBookForClear.copiesBorrowed,
            +selectedBookForClear.copiesBorrowed
          );
        }

        if (oldStatus === "Damaged" && clearStatus === "Resolved") {
          if (selectedBookForClear.damageType === "Unusable") {
            updateData = {
              totalCopies: currentTotalCopies + 1,
              copiesAvailable: currentCopiesAvailable + 1,
            };
          } else if (selectedBookForClear.damageType === "Repairable") {
            updateData = {
              copiesAvailable: currentCopiesAvailable + 1,
            };
          }
        }
        if (clearStatus === "Paid") {
          const paidBooksRef = collection(db, "paidBooks");
          await addDoc(paidBooksRef, {
            title: selectedBookForClear.title,
            author: selectedBookForClear.author,
            borrower: selectedBookForClear.borrowedBy,
            libraryCardNumber: selectedBookForClear.libraryCardNumber || "N/A",
            staffId: selectedBookForClear.staffId || "N/A",
            bookId: selectedBookForClear.bookId,
            paidAmount: selectedBookForClear.fine || 0,
            copiesBorrowed: parseInt(selectedBookForClear.copiesBorrowed) || 1,
            datePaid: Timestamp.now(),
            handledBy: localStorage.getItem("userName"),
            status:
              oldStatus === "Missing" ? "Missing - Paid" : "Damaged - Paid",
          });
        }

        if (Object.keys(updateData).length > 0) {
          await updateDoc(matchedBookRef, updateData);
        }
      }

      await logActivity(
        selectedBookForClear.title,
        oldStatus,
        clearStatus,
        selectedBookForClear.fine || 0,
        clearStatus === "Paid" ? "finePaid" : "clearBookStatus",
        `Book status updated from "${oldStatus}" to "${clearStatus}" (${resolveType})`
      );

      message.success(`Book marked as ${clearStatus} successfully!`);
      setIsClearModalVisible(false);
      setClearStatus("");
      setSelectedBookForClear(null);
      await fetchIssuedBook();
      await fetchPaidBooks();
    } catch (error) {
      console.error(error);
      message.error("Failed to update the book status. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const logActivity = async (
    bookTitle,
    oldStatus,
    newStatus,
    fineAmount,
    actionType,
    actionDescription
  ) => {
    try {
      const userName = localStorage.getItem("userName");
      const logRef = collection(db, "user-activity-logs");

      const now = new Date();
      const formattedDateTime = now.toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });

      await addDoc(logRef, {
        bookTitle: bookTitle,
        oldStatus: oldStatus,
        newStatus: newStatus,
        fineAmount: fineAmount,
        updatedBy: userName,
        timestamp: now,
        formattedDateTime,
        actionType: actionType,
        actionDescription: actionDescription,
      });
    } catch (error) {
      message.error("Failed to log activity:", error);
    }
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      await fetchIssuedBook();
      await fetchReturnedBooks();
      setLoading(false);
    };

    fetchData();
    const interval = setInterval(() => {
      setIssuedBooks((prevBooks) =>
        prevBooks.map((book) => ({
          ...book,
          duration: calculateRemainingDuration(book.dueDate),
        }))
      );
    }, 24 * 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const handleReturnBook = async (book) => {
    if (!book || !book.bookId) {
      message.error("Invalid book data");
      return;
    }

    let copiesToReturn = 1;
    let returnStatus = "Good";

    Modal.confirm({
      title: `Returning books for "${book.title}"`,
      content: (
        <>
          <p>
            How many copies are being returned? (Borrowed: {book.copiesBorrowed}
            )
          </p>
          <InputNumber
            min={1}
            max={book.copiesBorrowed}
            defaultValue={1}
            onChange={(value) => (copiesToReturn = value)}
            style={{ width: "100%" }}
          />
          <p>Book Status</p>
          <Select
            className="dept-option"
            style={{ width: "100%" }}
            placeholder="Select Book Status"
            onChange={(value) => (returnStatus = value)}
          >
            <Select.Option value="Good">Good</Select.Option>
            <Select.Option value="Damaged">Damaged</Select.Option>
            <Select.Option value="Missing">Missing</Select.Option>
          </Select>
        </>
      ),
      onOk: async () => {
        try {
          setLoading(true);
          console.log("Processing return...");

          const issuedBookRef = doc(db, "issuedBooks", book.key);
          const booksRef = collection(db, "books");

          const booksSnapshot = await getDocs(booksRef);
          const matchedBook = booksSnapshot.docs.find(
            (doc) => doc.id === book.bookId
          );

          if (!matchedBook) {
            console.error("Book record not found.");
            message.error("Book record not found.");
            setLoading(false);
            return;
          }

          const matchedBookRef = doc(db, "books", matchedBook.id);
          let currentCopiesAvailable = parseInt(
            matchedBook.data().copiesAvailable
          );
          let newIssuedCopies = book.copiesBorrowed - copiesToReturn;

          console.log(`New issued copies: ${newIssuedCopies}`);

          if (returnStatus === "Good") {
            if (newIssuedCopies > 0) {
              await updateDoc(issuedBookRef, {
                copiesBorrowed: newIssuedCopies,
              });
            } else {
              await deleteDoc(issuedBookRef);
            }

            await addDoc(collection(db, "returnedBooks"), {
              title: book.title,
              author: book.author,
              borrowedBy: book.borrowedBy,
              copiesReturned: copiesToReturn,
              returnedDate: Timestamp.now(),
              receivedBy: localStorage.getItem("userName"),
              dueDate: book.dueDate,
              department: book.department,
            });

            await updateDoc(matchedBookRef, {
              copiesAvailable: currentCopiesAvailable + copiesToReturn,
            });

            message.success("Books returned successfully!");
          } else {
            if (newIssuedCopies > 0) {
              await updateDoc(issuedBookRef, {
                copiesBorrowed: newIssuedCopies,
              });
            } else {
              await deleteDoc(issuedBookRef);
            }

            const { key, ...newEntry } = book;

            await addDoc(collection(db, "issuedBooks"), {
              ...newEntry,
              copiesBorrowed: copiesToReturn,
              status: returnStatus,
              reportedDate: Timestamp.now(),
            });

            message.warning(`Books marked as ${returnStatus}. Status updated.`);
          }

          await fetchIssuedBook();
          await fetchReturnedBooks();
        } catch (error) {
          console.error("Error processing book return:", error);
          message.error("Failed to process book return.");
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const handleStatusClick = (book) => {
    setSelectedBook(book);
    setNewStatus(book.status);
    setIsStatusModalVisible(true);
  };

  const handleStatusUpdate = () => {
    setLoading(true);
    if (newStatus === "Damaged") {
      if (!damageType) {
        message.error(
          "Please select whether the book is Unusable or Repairable."
        );
        setLoading(false);
        return;
      }
    }

    if (newStatus === "Damaged" || newStatus === "Missing") {
      setIsStatusModalVisible(false);
      setIsFineModalVisible(true);
      setTimeout(() => {
        setLoading(false);
      }, 300);
    } else {
      updateBookStatus(newStatus, fine);
    }
  };

  const handleFineUpdate = async () => {
    setLoading(true);

    setIsFineModalVisible(false);

    try {
      await updateBookStatus(newStatus, fine);
      setLoading(false);
    } catch (error) {
      message.error("Failed to update book status. Please try again.");
      setLoading(false);
    }
  };

  const updateBookStatus = async (status, fineAmount) => {
    if (!selectedBook) return;
    setLoading(true);

    try {
      const bookRef = doc(db, "issuedBooks", selectedBook.key);
      const oldStatus = selectedBook.status;
      const actionType = "updateBookStatus";

      const updatePayload = {
        status,
        fine: fineAmount,
      };

      if (status === "Damaged" || status === "Missing") {
        updatePayload.reportedBy = localStorage.getItem("userName");
        updatePayload.reportedDate = Timestamp.now();
      }

      if (status === "Damaged" && damageType) {
        updatePayload.damageType = damageType;
      }

      await updateDoc(bookRef, updatePayload);

      const booksRef = collection(db, "books");
      const booksSnapshot = await getDocs(booksRef);
      const matchedBook = booksSnapshot.docs.find(
        (doc) => doc.id === selectedBook.bookId
      );

      if (matchedBook) {
        const matchedBookRef = doc(db, "books", matchedBook.id);
        let currentTotalCopies = parseInt(matchedBook.data().totalCopies) || 0;
        let currentCopiesAvailable =
          parseInt(matchedBook.data().copiesAvailable) || 0;

        let updateData = {};

        if (
          (status === "Missing" && oldStatus !== "Missing") ||
          (status === "Damaged" && oldStatus !== "Damaged")
        ) {
          await adjustInventory(selectedBook.bookId, -1);
        }
      }

      const actionDescription = `Book status updated from "${oldStatus}" to "${status}" with a fine of ₱${fineAmount}`;
      await logActivity(
        selectedBook.title,
        oldStatus,
        status,
        fineAmount,
        actionType,
        actionDescription
      );

      message.success("Book status updated successfully!");
      setIsStatusModalVisible(false);
      setIsFineModalVisible(false);
      setSelectedBook(null);
      setFine(0);
      setNewStatus("");
      setDamageType("");
      await fetchIssuedBook();
    } catch (error) {
      message.error("Failed to update book status. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const openReturnModal = (book) => {
    setReturningBook(book);
    setCopiesToReturn(1);
    setReturnStatus("Good");
    setReturnFine(0);
    setIsReturnModalVisible(true);
  };

  const adjustInventory = async (bookId, deltaTotal, deltaAvailable = 0) => {
    const booksRef = collection(db, "books");
    const booksSnapshot = await getDocs(booksRef);
    const matchedBook = booksSnapshot.docs.find((doc) => doc.id === bookId);

    if (matchedBook) {
      const bookDocRef = doc(db, "books", matchedBook.id);
      const data = matchedBook.data();
      const newTotal = Math.max(
        (parseInt(data.totalCopies) || 0) + deltaTotal,
        0
      );
      const newAvailable = Math.max(
        (parseInt(data.copiesAvailable) || 0) + deltaAvailable,
        0
      );
      await updateDoc(bookDocRef, {
        totalCopies: newTotal,
        copiesAvailable: newAvailable,
      });
    }
  };

  const submitReturnBook = async () => {
    if (!returningBook) return;

    setLoading(true);

    try {
      const issuedBookRef = doc(db, "issuedBooks", returningBook.key);
      const booksSnapshot = await getDocs(collection(db, "books"));
      const matchedBook = booksSnapshot.docs.find(
        (doc) => doc.id === returningBook.bookId
      );
      const matchedBookRef = doc(db, "books", matchedBook.id);

      const newIssuedCopies = returningBook.copiesBorrowed - copiesToReturn;

      if (returnStatus === "Good") {
        if (newIssuedCopies > 0) {
          await updateDoc(issuedBookRef, { copiesBorrowed: newIssuedCopies });
        } else {
          await deleteDoc(issuedBookRef);
        }

        await addDoc(collection(db, "returnedBooks"), {
          ...returningBook,
          copiesReturned: copiesToReturn,
          returnedDate: Timestamp.now(),
          receivedBy: localStorage.getItem("userName"),
        });

        await updateDoc(matchedBookRef, {
          copiesAvailable:
            parseInt(matchedBook.data().copiesAvailable || 0) + copiesToReturn,
        });

        message.success("Book returned successfully.");
      } else {
        const { key, ...bookData } = returningBook;

        await addDoc(collection(db, "issuedBooks"), {
          ...bookData,
          copiesBorrowed: copiesToReturn,
          status: returnStatus,
          reportedDate: Timestamp.now(),
          fine: returnFine,
        });

        if (newIssuedCopies > 0) {
          await updateDoc(issuedBookRef, { copiesBorrowed: newIssuedCopies });
        } else {
          await deleteDoc(issuedBookRef);
        }
        await adjustInventory(returningBook.bookId, -copiesToReturn, 0);

        message.warning(`Book marked as ${returnStatus}. Fine applied.`);
      }

      setIsReturnModalVisible(false);
      await fetchIssuedBook();
      await fetchReturnedBooks();
    } catch (error) {
      console.error("Return Error:", error);
      message.error("Failed to return book. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchPaidBooks = async () => {
    try {
      const paidBooksRef = collection(db, "paidBooks");
      const paidBooksSnapshot = await getDocs(paidBooksRef);
      const paidBooksData = paidBooksSnapshot.docs.map((doc) => ({
        ...doc.data(),
        key: doc.id,
      }));

      setPaidBooks(paidBooksData);
    } catch (error) {
      message.error("Failed to load Paid Books.");
    }
  };

  useEffect(() => {
    fetchPaidBooks();
  }, []);

  const handleViewBook = (book, type = "issued") => {
    setSelectedBookDetails(book);
    setBookType(type);
    setIsViewModalVisible(true);
  };

  useEffect(() => {
    const totalIssued = issuedBooks
      .filter(
        (book) =>
          book.status !== "Damaged" &&
          book.status !== "Missing" &&
          book.status !== "Resolved" &&
          book.status !== "Paid"
      )
      .reduce((sum, book) => sum + (book.copiesBorrowed || 0), 0);

    const totalReturned = returnedBooks.reduce(
      (sum, book) => sum + (book.copiesReturned || 0),
      0
    );

    const totalDamagedMissing = issuedBooks
      .filter((book) => book.status === "Damaged" || book.status === "Missing")
      .reduce((sum, book) => sum + (book.copiesBorrowed || 0), 0);

    const totalPaidNotReturned = paidBooks.reduce(
      (sum, book) => sum + (book.copiesBorrowed || 1),
      0
    );

    setSummaryCounts({
      issued: totalIssued,
      returned: totalReturned,
      damagedMissing: totalDamagedMissing,
      paidNotReturned: totalPaidNotReturned,
      resolved: totalResolved,
    });
  }, [issuedBooks, returnedBooks, paidBooks]);

  const borrowedColumns = [
    {
      title: "Book Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Borrowed By",
      dataIndex: "borrowedBy",
      key: "borrowedBy",
      filters: issuedBooks
        .map((book) => book.borrowedBy)
        .filter((value, index, self) => value && self.indexOf(value) === index)
        .map((borrower) => ({
          text: borrower,
          value: borrower,
        })),
      onFilter: (value, record) =>
        record.borrowedBy?.toLowerCase().includes(value.toLowerCase()),
      filterSearch: true,
      width: "40%",
    },

    {
      title: "Issued Date",
      dataIndex: "issuedAt",
      key: "issuedAt",
      render: (text) => {
        const date = text?.toDate?.();
        return date ? moment(date).format("MM/DD/YYYY") : "N/A";
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="MM/DD/YYYY"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: 90 }}
            >
              Filter
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                confirm({ closeDropdown: false });
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      onFilter: (value, record) => {
        const issuedAt = record.issuedAt;
        if (!issuedAt || !value) return false;

        const recordDate = moment(issuedAt.toDate()).format("MM/DD/YYYY");
        const input = value.trim();
        return recordDate === input;
      },
    },
    {
      title: "Due Date",
      dataIndex: "dueDate",
      key: "dueDate",
      render: (text) => {
        const dueDate = text?.toDate();
        return dueDate ? dueDate.toLocaleDateString() : "N/A";
      },
    },
    {
      title: "Duration",
      key: "duration",
      render: (_, record) => calculateRemainingDuration(record.dueDate),
    },
    {
      title: "Book Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => {
        let tagColor;

        switch (status) {
          case "Fine":
            tagColor = "gold";
            break;
          case "Damaged":
            tagColor = "gold";
            break;
          case "Missing":
            tagColor = "gold";
            break;
          default:
            tagColor = "gold";
        }

        return (
          <Tag title="Missing or Damaged Book?" color={tagColor} key={tagColor}>
            {status}
          </Tag>
        );
      },
    },

    {
      title: "Action",
      key: "action",
      render: (record) => {
        return (
          <span>
            <Button type="primary" onClick={() => openReturnModal(record)}>
              Return Book
            </Button>

            <Tooltip
              title="View Issued Book Details"
              placement="left"
              overlayInnerStyle={{
                backgroundColor: "#FFFFFF",
                color: "#000000",
              }}
              color="#FFFFFF"
            >
              <Button
                type="link"
                icon={<EyeOutlined className="action-icon" />}
                style={{ marginRight: 8 }}
                onClick={() => handleViewBook(record, "issued")}
              />
            </Tooltip>
          </span>
        );
      },
    },
  ];

  const missingAndDamagedBook = [
    {
      title: "Book Title",
      dataIndex: "title",
      key: "title",
      fixed: "left",
    },

    {
      title: "Borrowed By",
      dataIndex: "borrowedBy",
      key: "borrowedBy",
      filters: issuedBooks
        .map((book) => book.borrowedBy)
        .filter((value, index, self) => value && self.indexOf(value) === index)
        .map((borrower) => ({
          text: borrower,
          value: borrower,
        })),
      onFilter: (value, record) =>
        record.borrowedBy?.toLowerCase().includes(value.toLowerCase()),
      filterSearch: true,
    },
    {
      title: "Issued Date",
      dataIndex: "issuedAt",
      key: "issuedAt",
      render: (text) => {
        const dueDate = text?.toDate();
        return dueDate ? dueDate.toLocaleDateString() : "N/A";
      },
    },

    {
      title: "Due Date",
      dataIndex: "dueDate",
      key: "dueDate",
      render: (text) => {
        const dueDate = text?.toDate();
        return dueDate ? dueDate.toLocaleDateString() : "N/A";
      },
    },

    {
      title: "Book Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => {
        let tagColor;

        switch (status) {
          case "Resolved":
            tagColor = "green";
            break;
          case "Damaged":
            tagColor = "red";
            break;
          case "Missing":
            tagColor = "gray";
            break;
          default:
            tagColor = "orange";
        }

        return <Tag color={tagColor}>{status}</Tag>;
      },
    },
    {
      title: "Applied Fine",
      dataIndex: "fine",
      key: "fine",
      render: (fine) => (fine > 0 ? `₱${fine}.00` : "No Applied Fine"),
    },

    {
      title: "Action",
      key: "action",
      render: (record) => {
        return (
          <span>
            <Button type="primary" onClick={() => handleClearClick(record)}>
              Clear
            </Button>
            <Tooltip
              title={
                record.status === "Missing"
                  ? "View Missing Book Details"
                  : "View Damaged Book Details"
              }
              placement="left"
              overlayInnerStyle={{
                backgroundColor: "#FFFFFF",
                color: "#000000",
              }}
              color="#FFFFFF"
            >
              <Button
                type="link"
                icon={<EyeOutlined className="action-icon" />}
                style={{ marginRight: 8 }}
                onClick={() => handleViewBook(record, "damagedMissing")}
              />
            </Tooltip>
          </span>
        );
      },
    },
  ];

  const returnedColumns = [
    {
      title: "Book Title",
      dataIndex: "title",
      key: "title",
      fixed: "left",
    },
    {
      title: "Book Author",
      dataIndex: "author",
      key: "author",
    },
    {
      title: "Returned By",
      dataIndex: "borrowedBy",
      key: "borrowedBy",
      filters: returnedBooks
        .map((book) => book.borrowedBy)
        .filter((value, index, self) => value && self.indexOf(value) === index)
        .map((borrower) => ({
          text: borrower,
          value: borrower,
        })),
      onFilter: (value, record) =>
        record.borrowedBy?.toLowerCase().includes(value.toLowerCase()),
      filterSearch: true,
    },
    {
      title: "Returned Date",
      dataIndex: "returnedDate",
      key: "returnedDate",
      render: (text) => {
        if (text instanceof Timestamp) {
          const returnedDate = text.toDate();
          return returnedDate
            ? moment(returnedDate).format("MM/DD/YYYY")
            : "N/A";
        } else {
          return "N/A";
        }
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="MM/DD/YYYY"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: 90 }}
            >
              Filter
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                confirm({ closeDropdown: false }); // Instant refresh
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      onFilter: (value, record) => {
        const returned = record.returnedDate;
        if (!returned || !value) return false;

        const date = returned instanceof Timestamp ? returned.toDate() : null;
        const formatted = moment(date).format("MM/DD/YYYY");
        return formatted === value.trim();
      },
    },

    {
      title: "Received By",
      dataIndex: "receivedBy",
      key: "receivedBy",
    },
    {
      title: "Action",
      key: "action",
      render: (record) => {
        return (
          <span>
            <Tooltip
              title="View Returned Book Details"
              placement="left"
              overlayInnerStyle={{
                backgroundColor: "#FFFFFF",
                color: "#000000",
              }}
              color="#FFFFFF"
            >
              <Button
                type="link"
                className="action-icon"
                icon={<EyeOutlined className="action-icon" />}
                style={{ marginRight: 8 }}
                onClick={() => handleViewBook(record, "returned")}
              />
            </Tooltip>
          </span>
        );
      },
    },
  ];

  const resolvedBooksColumns = [
    {
      title: "Book Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Borrowed By",
      dataIndex: "borrowedBy",
      key: "borrowedBy",
      filters: resolvedBooks
        .map((book) => book.borrowedBy)
        .filter((value, index, self) => value && self.indexOf(value) === index)
        .map((borrower) => ({
          text: borrower,
          value: borrower,
        })),
      onFilter: (value, record) =>
        record.borrowedBy?.toLowerCase().includes(value.toLowerCase()),
      filterSearch: true,
    },
    {
      title: "Resolve Type",
      dataIndex: "resolveType",
      key: "resolveType",
      filters: [
        { text: "Repaired", value: "Repaired" },
        { text: "Replaced", value: "Replaced" },
      ],
      onFilter: (value, record) => record.resolveType === value,
      render: (text) => text || "—",
    },

    {
      title: "Copies",
      dataIndex: "copiesBorrowed",
      key: "copiesBorrowed",
      render: (copies) => copies || 1,
    },

    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Tooltip
          title="View Resolved Book Details"
          placement="left"
          overlayInnerStyle={{
            backgroundColor: "#FFFFFF",
            color: "#000000",
          }}
          color="#FFFFFF"
        >
          <Button
            type="link"
            icon={<EyeOutlined className="action-icon" />}
            onClick={() => handleViewBook(record, "resolved")}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <div className="tab-main-container">
      <div
        className="summary-counts"
        style={{
          marginBottom: 20,
          display: "flex",
          gap: "20px",
          flexWrap: "wrap",
        }}
      >
        <div className="statistic-container statistic-student">
          <Statistic
            title="📚 Total Issued Book"
            value={summaryCounts.issued}
          />
        </div>
        <div className="statistic-container statistic-student">
          <Statistic
            title="🔁 Total Returned Books"
            value={summaryCounts.returned}
          />
        </div>
        <div className="statistic-container statistic-student">
          <Statistic
            title="⚠️ Damaged/Missing"
            value={summaryCounts.damagedMissing}
          />
        </div>
        <div className="statistic-container statistic-student">
          <Statistic
            title="💸 Paid (Not Returned)"
            value={summaryCounts.paidNotReturned}
          />
        </div>
        <div className="statistic-container statistic-student last-statistics">
          <Statistic title="🛠️ Resolved Books" value={summaryCounts.resolved} />
        </div>
      </div>

      <Tabs
        className="custom-tab"
        defaultActiveKey="1"
        tabBarStyle={{
          borderBottom: "1px solid #fff",
        }}
        items={[
          {
            key: "1",
            label: (
              <span className="custom-tab-label">
                <ReadOutlined /> Issued Book
              </span>
            ),
            children: (
              <Table
                className="custom-table"
                dataSource={filteredIssuedBooks}
                columns={borrowedColumns}
                pagination={{ pageSize: 4, size: "middle" }}
                scroll={{ x: "max-content" }}
                locale={{
                  emptyText: loading ? (
                    <Spin tip="Loading Books..." />
                  ) : (
                    <span>
                      <img className="noData" src={noData} /> No Issued Book
                      Found
                    </span>
                  ),
                }}
              />
            ),
          },
          {
            key: "2",
            label: (
              <span className="custom-tab-label">
                <RollbackOutlined /> Returned Books
              </span>
            ),
            children: (
              <Table
                className="custom-table"
                dataSource={returnedBooks}
                columns={returnedColumns}
                pagination={{ pageSize: 4, size: "middle" }}
                scroll={{ x: 1000 }}
              />
            ),
          },
          {
            key: "3",
            label: (
              <span className="custom-tab-label">
                <WarningOutlined /> Damaged and Missing Book
              </span>
            ),
            children: (
              <Table
                className="custom-table"
                dataSource={damagedAndMissingBooks}
                columns={missingAndDamagedBook}
                pagination={{ pageSize: 4, size: "middle" }}
                scroll={{ x: 1000 }}
              />
            ),
          },
          {
            key: "4",
            label: (
              <span className="custom-tab-label">
                <WarningOutlined /> Paid but Not Returned
              </span>
            ),
            children: (
              <Table
                className="custom-table"
                dataSource={paidBooks}
                columns={[
                  {
                    title: "Book Title",
                    dataIndex: "title",
                    key: "title",
                    fixed: "left",
                  },
                  {
                    title: "Book Author",
                    dataIndex: "author",
                    key: "author",
                  },
                  {
                    title: "Borrower",
                    dataIndex: "borrower",
                    key: "borrower",
                    filters: paidBooks
                      .map((book) => book.borrower)
                      .filter(
                        (value, index, self) =>
                          value && self.indexOf(value) === index
                      )
                      .map((borrower) => ({
                        text: borrower,
                        value: borrower,
                      })),
                    onFilter: (value, record) =>
                      record.borrower
                        ?.toLowerCase()
                        .includes(value.toLowerCase()),
                    filterSearch: true,
                  },

                  {
                    title: "Applied Fine",
                    dataIndex: "paidAmount",
                    key: "paidAmount",
                    render: (text) => `₱ ${text}.00`,
                  },
                  {
                    title: "Date Paid",
                    dataIndex: "datePaid",
                    key: "datePaid",
                    render: (text) => {
                      if (text instanceof Timestamp) {
                        return text.toDate().toLocaleDateString();
                      }
                      return new Date(text).toLocaleDateString();
                    },
                  },
                  {
                    title: "Handled By",
                    dataIndex: "handledBy",
                    key: "handledBy",
                  },
                  {
                    title: "Action",
                    key: "action",
                    render: (record) => (
                      <Tooltip
                        title="View Paid Book Details"
                        placement="left"
                        overlayInnerStyle={{
                          backgroundColor: "#FFFFFF",
                          color: "#000000",
                        }}
                        color="#FFFFFF"
                      >
                        <Button
                          type="link"
                          icon={<EyeOutlined className="action-icon" />}
                          onClick={() => handleViewBook(record, "paid")}
                        />
                      </Tooltip>
                    ),
                  },
                ]}
                pagination={{ pageSize: 4, size: "middle" }}
                scroll={{ x: 1000 }}
              />
            ),
          },

          {
            key: "5",
            label: (
              <span className="custom-tab-label">
                <SmileOutlined /> Resolved Books
              </span>
            ),
            children: (
              <Table
                className="custom-table"
                dataSource={resolvedBooks}
                columns={resolvedBooksColumns}
                pagination={{ pageSize: 4, size: "middle" }}
                scroll={{ x: 1000 }}
              />
            ),
          },
        ]}
      />

      <Modal
        className="custom-modal"
        title="Update Book Status"
        visible={isStatusModalVisible}
        onCancel={() => setIsStatusModalVisible(false)}
        onOk={handleStatusUpdate}
        confirmLoading={loading}
      >
        <p>Select the new status for the book:</p>
        <Select
          style={{ width: "100%" }}
          value={newStatus}
          onChange={(value) => setNewStatus(value)}
        >
          <Select.Option value="Good">Good</Select.Option>
          <Select.Option value="Damaged">Damaged</Select.Option>
          <Select.Option value="Missing">Missing</Select.Option>
        </Select>
        {newStatus === "Damaged" && (
          <>
            <p>Is this book unusable or repairable?</p>
            <Select
              style={{ width: "100%" }}
              value={damageType}
              onChange={(value) => setDamageType(value)}
            >
              <Select.Option value="Unusable">
                Unusable (Remove from Inventory)
              </Select.Option>
              <Select.Option value="Repairable">
                Repairable (Reduce Available Copies)
              </Select.Option>
            </Select>
          </>
        )}
      </Modal>
      <Modal
        className="custom-modal"
        title="Apply Fine"
        visible={isFineModalVisible}
        onCancel={() => setIsFineModalVisible(false)}
        onOk={handleFineUpdate}
        confirmLoading={loading}
      >
        <p>
          This book is marked as <strong>{newStatus}</strong>. Apply a fine if
          necessary:
        </p>
        <InputNumber
          style={{ width: "100%" }}
          value={fine}
          onChange={(value) => setFine(value)}
          min={0}
          step={1}
          placeholder="Enter fine amount"
        />
      </Modal>
      <Modal
        className="custom-modal"
        title="Clear Book Status"
        visible={isClearModalVisible}
        onCancel={() => {
          if (!loading) setIsClearModalVisible(false);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => setIsClearModalVisible(false)}
            disabled={loading}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleClearStatus}
            loading={loading}
          >
            Confirm
          </Button>,
        ]}
      >
        <p>Select the new status for this book:</p>
        <Select
          style={{ width: "100%" }}
          value={clearStatus}
          onChange={(value) => setClearStatus(value)}
        >
          <Select.Option value="Resolved">Resolved</Select.Option>
          <Select.Option value="Paid">Paid</Select.Option>
        </Select>
        {clearStatus === "Resolved" && (
          <>
            <p>Was the book repaired or replaced?</p>
            <Select
              style={{ width: "100%" }}
              value={resolveType}
              onChange={(value) => setResolveType(value)}
              placeholder="Select resolution type"
            >
              <Select.Option value="Repaired">Repaired</Select.Option>
              <Select.Option value="Replaced">
                Replaced with New Copy
              </Select.Option>
            </Select>
          </>
        )}
      </Modal>
      <Modal
        className="custom-modal"
        title={
          bookType === "issued"
            ? "Issued Book Details"
            : bookType === "returned"
            ? "Returned Book Details"
            : bookType === "resolved"
            ? "Resolved Book Details"
            : "Damaged/Missing Book Details"
        }
        visible={isViewModalVisible}
        onCancel={() => setIsViewModalVisible(false)}
        footer={null}
      >
        {selectedBookDetails && (
          <>
            {bookType === "issued" && (
              <Descriptions bordered column={1}>
                <Descriptions.Item label="Book Title">
                  {selectedBookDetails.title}
                </Descriptions.Item>
                <Descriptions.Item label="Book Author">
                  {selectedBookDetails.author}
                </Descriptions.Item>
                <Descriptions.Item label="Borrowed By">
                  {selectedBookDetails.borrowedBy}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower Library Card Number">
                  {selectedBookDetails.libraryCardNumber || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower ID Number">
                  {selectedBookDetails.staffId || "N/A"}
                </Descriptions.Item>

                <Descriptions.Item label="Issued Date">
                  {selectedBookDetails.issuedAt instanceof Timestamp
                    ? selectedBookDetails.issuedAt.toDate().toLocaleString()
                    : "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Due Date">
                  {selectedBookDetails.dueDate instanceof Timestamp
                    ? selectedBookDetails.dueDate.toDate().toLocaleString()
                    : "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Copies Borrowed">
                  {selectedBookDetails.copiesBorrowed || 1}
                </Descriptions.Item>
                <Descriptions.Item label="Book Status">
                  {selectedBookDetails.status}
                </Descriptions.Item>
                <Descriptions.Item label="Accommodated By">
                  {selectedBookDetails.accommodatedBy || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower Phone Number">
                  {selectedBookDetails.number || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower Email">
                  {selectedBookDetails.email || "N/A"}
                </Descriptions.Item>
              </Descriptions>
            )}

            {bookType === "returned" && (
              <Descriptions bordered column={1}>
                <Descriptions.Item label="Book Title">
                  {selectedBookDetails.title}
                </Descriptions.Item>
                <Descriptions.Item label="Book Author">
                  {selectedBookDetails.author}
                </Descriptions.Item>
                <Descriptions.Item label="Borrowed By">
                  {selectedBookDetails.borrowedBy}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower Library Card Number">
                  {selectedBookDetails.libraryCardNumber || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower ID Number">
                  {selectedBookDetails.staffId || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower Library Card Number">
                  {selectedBookDetails.libraryCardNumber || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower ID Number">
                  {selectedBookDetails.staffId || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Issued Date">
                  {selectedBookDetails.issuedAt instanceof Timestamp
                    ? selectedBookDetails.issuedAt.toDate().toLocaleString()
                    : "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Due Date">
                  {selectedBookDetails.dueDate instanceof Timestamp
                    ? selectedBookDetails.dueDate.toDate().toLocaleString()
                    : "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Returned Date">
                  {selectedBookDetails.returnedDate instanceof Timestamp
                    ? selectedBookDetails.returnedDate.toDate().toLocaleString()
                    : "N/A"}
                </Descriptions.Item>

                <Descriptions.Item label="Copies Returned">
                  {selectedBookDetails.copiesReturned}
                </Descriptions.Item>
                <Descriptions.Item label="Received By">
                  {selectedBookDetails.receivedBy || "N/A"}
                </Descriptions.Item>

                <Descriptions.Item label="Borrower Department">
                  {Array.isArray(selectedBookDetails.department)
                    ? selectedBookDetails.department.join(", ")
                    : selectedBookDetails.department || "N/A"}
                </Descriptions.Item>
              </Descriptions>
            )}

            {bookType === "damagedMissing" && (
              <Descriptions bordered column={1}>
                <Descriptions.Item label="Book Title">
                  {selectedBookDetails.title}
                </Descriptions.Item>
                <Descriptions.Item label="Book Author">
                  {selectedBookDetails.author}
                </Descriptions.Item>
                <Descriptions.Item label="Borrowed By">
                  {selectedBookDetails.borrowedBy}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower Library Card Number">
                  {selectedBookDetails.libraryCardNumber || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower ID Number">
                  {selectedBookDetails.staffId || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Accommodated By">
                  {selectedBookDetails.accommodatedBy || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Reported By">
                  {selectedBookDetails.reportedBy || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Reported Date">
                  {selectedBookDetails.reportedDate instanceof Timestamp
                    ? selectedBookDetails.reportedDate.toDate().toLocaleString()
                    : "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Issued Date">
                  {selectedBookDetails.issuedAt instanceof Timestamp
                    ? selectedBookDetails.issuedAt.toDate().toLocaleString()
                    : "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Due Date">
                  {selectedBookDetails.dueDate instanceof Timestamp
                    ? selectedBookDetails.dueDate.toDate().toLocaleString()
                    : "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Copies Affected">
                  {selectedBookDetails.copiesBorrowed || 1}
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                  {selectedBookDetails.status}
                </Descriptions.Item>
                <Descriptions.Item label="Applied Fine">
                  {selectedBookDetails.fine > 0
                    ? `₱${selectedBookDetails.fine}.00`
                    : "No Fine"}
                </Descriptions.Item>
              </Descriptions>
            )}

            {bookType === "resolved" && (
              <Descriptions bordered column={1}>
                <Descriptions.Item label="Book Title">
                  {selectedBookDetails.title}
                </Descriptions.Item>
                <Descriptions.Item label="Book Author">
                  {selectedBookDetails.author}
                </Descriptions.Item>
                <Descriptions.Item label="Borrowed By">
                  {selectedBookDetails.borrowedBy}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower Library Card Number">
                  {selectedBookDetails.libraryCardNumber || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower ID Number">
                  {selectedBookDetails.staffId || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Resolved By">
                  {selectedBookDetails.resolvedBy || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Copies Resolves">
                  {selectedBookDetails.copiesBorrowed || 1}
                </Descriptions.Item>
                <Descriptions.Item label="Issued Date">
                  {selectedBookDetails.issuedAt instanceof Timestamp
                    ? selectedBookDetails.issuedAt.toDate().toLocaleString()
                    : "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Resolved Date">
                  {selectedBookDetails.resolvedDate instanceof Timestamp
                    ? selectedBookDetails.resolvedDate.toDate().toLocaleString()
                    : "N/A"}
                </Descriptions.Item>

                <Descriptions.Item label="Resolve Type">
                  {selectedBookDetails.resolveType || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                  {selectedBookDetails.status}
                </Descriptions.Item>
              </Descriptions>
            )}
            {bookType === "paid" && (
              <Descriptions bordered column={1}>
                <Descriptions.Item label="Book Title">
                  {selectedBookDetails.title}
                </Descriptions.Item>
                <Descriptions.Item label="Book Author">
                  {selectedBookDetails.author}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower Name">
                  {selectedBookDetails.borrower}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower Library Card Number">
                  {selectedBookDetails.libraryCardNumber || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Borrower ID Number">
                  {selectedBookDetails.staffId || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Copies Paid For">
                  {selectedBookDetails.copiesBorrowed || 1}
                </Descriptions.Item>
                <Descriptions.Item label="Amount Paid">
                  ₱ {selectedBookDetails.paidAmount}.00
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                  {selectedBookDetails.status}
                </Descriptions.Item>
                <Descriptions.Item label="Date Paid">
                  {selectedBookDetails.datePaid instanceof Timestamp
                    ? selectedBookDetails.datePaid.toDate().toLocaleString()
                    : "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Handled By">
                  {selectedBookDetails.handledBy || "N/A"}
                </Descriptions.Item>
              </Descriptions>
            )}
          </>
        )}
      </Modal>
      <Modal
        title={`Return Book - ${returningBook?.title || ""}`}
        visible={isReturnModalVisible}
        onCancel={() => {
          if (!loading) setIsReturnModalVisible(false);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => setIsReturnModalVisible(false)}
            disabled={loading}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={submitReturnBook}
            loading={loading}
          >
            Return Book
          </Button>,
        ]}
        className="custom-modal"
      >
        <p>
          How many copies are being returned? (Borrowed:{" "}
          {returningBook?.copiesBorrowed || 1})
        </p>
        <InputNumber
          min={1}
          max={returningBook?.copiesBorrowed || 1}
          value={copiesToReturn}
          onChange={setCopiesToReturn}
          style={{ width: "100%", marginBottom: 10 }}
        />
        <p>Select Book Status:</p>
        <Select
          value={returnStatus}
          onChange={setReturnStatus}
          style={{ width: "100%", marginBottom: 10 }}
        >
          <Select.Option value="Good">Good</Select.Option>
          <Select.Option value="Damaged">Damaged</Select.Option>
          <Select.Option value="Missing">Missing</Select.Option>
        </Select>
        {(returnStatus === "Damaged" || returnStatus === "Missing") && (
          <>
            <p>Fine Amount:</p>
            <InputNumber
              min={0}
              value={returnFine}
              onChange={setReturnFine}
              style={{ width: "100%" }}
              placeholder="Enter fine amount"
            />
          </>
        )}
      </Modal>
    </div>
  );
};

export default Transaction;
